import { FunctionComponent } from "react"
import { Button, Card } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

interface IKeycardDoorsCard {}
const KeycardDoorsCard: FunctionComponent<IKeycardDoorsCard> = () => {
	const navigate = useNavigate()
	return (
		<Card className="mt-4">
			<Card.Header>Verify Permissions</Card.Header>
			<Card.Body>
				<Card.Text>
					<ul>
						<li>View exactly what doors a keycard has access to</li>
						<li>
							If a keycard gets denied when it shouldn't be, check here first to see if the keycard has been entered
							correctly
						</li>
					</ul>
					<Button className="mt-4" onClick={() => navigate("/keycard-doors")}>
						View Permissions
					</Button>
				</Card.Text>
			</Card.Body>
		</Card>
	)
}
export default KeycardDoorsCard
